<div class="tapable-terminal-card" matRipple [style.width.px]="size" [style.height.px]="size">
    <ng-content></ng-content>
</div>